import { machineTypeSchema } from "@packsize/schemas/machines";

export const PL1_MACHINES_QUERY_KEY = ["machines", { machineType: machineTypeSchema.enum.PL1 }] as const;
